export const clearTokenErrorCodes = [99107, 99112];
